export const uk = {
  scene: {
    loading: 'Завантажуємо тло…',
    recovering: 'Відновлюємо зображення…',
    unavailable: 'Не вдалося завантажити тло',
    retryHint:
      'Повторюємо спробу. Якщо завантаження не завершиться, відкрийте застосунок знову.',
  },
  bootstrap: {
    loadingSpace: 'Налаштовуємо простір…',
    loadingOracle: 'Пробуджуємо Оракул…',
    startupError: 'Помилка запуску',
    retry: 'Спробувати ще раз',
    staleTelegram:
      'Сесія Telegram застаріла. Закрийте Mini App та відкрийте її знову.',
    authTelegramError: 'Не вдалося підтвердити вхід через Telegram',
    updateTelegramError:
      'Не вдалося оновити Mini App. Повністю закрийте її та відкрийте знову.',
    missingTelegramData:
      'Telegram не передав дані запуску. Закрийте Mini App та відкрийте її знову.',
  },
  back: 'Назад',
  close: 'Закрити',
  loading: 'Завантаження…',
  routeReading: {
    loading: 'Відкриваємо тлумачення…',
    error: 'Тлумачення недоступне',
    errorHint: 'Його могли видалити, або воно належить іншому профілю.',
    retry: 'Спробувати ще раз',
  },
  save: 'Зберегти',
  tomorrow: 'Завтра',
  collapse: 'Згорнути',
  app: {
    title: 'NEIRO ORACLE',
    subtitle: 'Система ворожіння v{{version}}',
    version: 'v{{version}}',
  },
  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: 'Як працює Оракул',
    introduction: 'Два способи звернутися до І-Цзін для різних потреб.',
    accessibilityLabel: 'Посібник зі знака дня та тлумачень',
    open: 'Як користуватися Оракулом',
    close: 'Закрити посібник',
    understood: 'Зрозуміло',
    daily: {
      title: 'Знак дня',
      body: 'Запитання не потрібне. Знак дає тему та практичний орієнтир на день.',
    },
    reading: {
      title: 'Розбір',
      body: 'Сформулюйте одне конкретне запитання й тримайте його в думках, кидаючи монети. Тлумачення показує поточну ситуацію, її зміни та можливий напрямок.',
    },
    journal: {
      title: 'Щоденник',
      body: 'Знаки дня та тлумачення зберігаються в спільній історії. Після тлумачення можна записати рішення.',
    },
    example: {
      title: 'Корисне запитання',
      body: '«Що мені варто врахувати перед розмовою з командою?»',
    },
  },
  dailyDetails: {
    title: 'Докладніше',
    loading: 'Завантажуємо знак…',
    loadError: 'Не вдалося завантажити знак вибраною мовою.',
    retry: 'Спробувати ще раз',
    fullText: 'Тема на сьогодні',
    situationEssence: 'Запитання для перевірки',
    innerTension: 'Що врахувати',
    action: 'Що зробити сьогодні',
    askAbout: 'Запитати про це',
    introduction:
      'Для знака дня запитання не потрібне. Він дає тему та практичний орієнтир на день.',
  },
  classicalText: {
    title: 'КЛАСИЧНИЙ ТЕКСТ',
    future: 'КЛАСИКА · МАЙБУТНІЙ ЗНАК',
    judgment: 'ВИСЛІВ ГЕКСАГРАМИ',
    lines: 'ВИСЛОВИ ЛІНІЙ',
    parallelLines: 'ЛІНІЇ ГЕКСАГРАМИ',
    line: 'Лінія {{number}}',
    lineStatement: 'КЛАСИЧНИЙ ВИСЛІВ',
    sourceLabel: 'І-Цзін',
    rulingLine: 'КЕРІВНА ЛІНІЯ',
    specialLine: 'Особливий вислів',
  },
  home: {
    title: 'NEIRO ORACLE',
    subtitle: 'Система ворожіння v{{version}}',
    statusText: '> Усі системи працюють',
    daily: {
      title: 'Знак дня',
      caption: 'Без запитання · тема та орієнтир на день',
      actionTitle: 'Дія на сьогодні',
      askNow: 'Почати ворожіння',
      moreDetails: 'Читати далі',
      hideDetails: 'Приховати подробиці',
      detailsTitle: 'Повний опис',
      lastResult: 'Останній результат',
      noLastResult: 'Немає',
      emptyState: 'Тлумачень ще немає. Почніть ворожіння →',
      empty: {
        subtitle: 'Натисніть, щоб отримати знак на сьогодні',
        hint: 'Ритуал одним дотиком',
        button: 'Отримати знак',
      },
      loading: {
        searching: 'Шукаємо гексаграму…',
        revealing: 'Відкриваємо шість ліній…',
      },
      pinnedToday: 'Закріплено на сьогодні',
      newSign: 'Новий знак',
      resetReasons: {
        title: 'Причина оновлення',
        sleep: 'Прокинувся після сну',
        situationChanged: 'Ситуація змінилася',
        other: 'Інше',
      },
      resetConfirm: {
        title: 'Оновити знак?',
        message:
          'Оновити знак для нового циклу неспання? Поточний залишиться в щоденнику.',
        confirm: 'Оновити',
        cancel: 'Скасувати',
      },
      nextUpdate: {
        prefix: 'Наступний новий знак —',
        afterSleep: 'після наступного сну',
        tomorrow: 'завтра о 07:00',
        or: 'або',
        available: 'доступний зараз',
      },
      updated: 'Знак оновлено — новий цикл неспання',
      limitReached: 'Досягнуто ліміту оновлень на сьогодні',
      disclaimer:
        'Для саморефлексії та розваги. Не є медичною чи фінансовою порадою.',
    },
    question: {
      title: 'Є конкретне запитання?',
      subtitle: 'Тлумачення розкриває ситуацію, її зміни та можливий напрямок',
      askNow: 'Почати ворожіння',
      hint: 'Без теми. Показує майбутню гексаграму, поточні та мінливі лінії',
    },
    buttons: {
      iching: 'ОРАКУЛ І-ЦЗІН',
      designSystem: 'ДИЗАЙН-СИСТЕМА',
      simpleTest: 'ПРОСТИЙ ТЕСТ',
      hexagramTest: 'ТЕСТ ГЕКСАГРАМ',
    },
  },
  iching: {
    title: 'ОРАКУЛ І-ЦЗІН',
    subtitle: 'МОБІЛЬНА ВЕРСІЯ v{{version}}',
    throwCoins: 'Кинути монети',
    castingHexagram: 'Складаємо гексаграму…',
    generationError:
      'Знак не склався. Перевірте з’єднання та повторіть ритуал.',
    retry: 'Спробувати ще раз',
    castingWisdom: {
      '1': 'Подорож у тисячу лі починається з одного кроку',
      '2': 'Не бійтеся йти повільно; бійтеся стояти на місці',
      '3': 'М’яке долає тверде, спокійне долає неспокійне',
      '4': 'Зміна — єдине постійне під небом',
      '5': 'Мудрі пристосовуються, як вода до форми посудини',
      '6': 'Коли знак складається, відповідь уже всередині вас',
    },
    instruction: 'Натисніть, щоб скласти гексаграму й отримати пораду',
    linkActive: 'ЗВ’ЯЗОК АКТИВНИЙ',
    backButton: '← НА ГОЛОВНУ',
    newDivination: 'НОВЕ ВОРОЖІННЯ',
    sections: {
      hexagrams: 'ГЕКСАГРАМИ',
      interpretation: 'ТЛУМАЧЕННЯ',
      aiInsights: 'СПОСТЕРЕЖЕННЯ ШІ',
      general: 'ЗАГАЛЬНЕ ТЛУМАЧЕННЯ',
      love: 'КОХАННЯ ТА СТОСУНКИ',
      work: 'РОБОТА ТА КАР’ЄРА',
      health: 'ЗДОРОВ’Я ТА ДОБРОБУТ',
      travel: 'ПОДОРОЖІ ТА ШЛЯХ',
      changingLines: 'МІНЛИВІ ЛІНІЇ',
      futureHexagram: 'МОЖЛИВИЙ СТАН',
      structuralFocus: 'ЩО УТРИМУЄ СИТУАЦІЮ',
    },
    hexagram: {
      current: 'ПОТОЧНА',
      future: 'МОЖЛИВА',
      present: 'ПОТОЧНА СИТУАЦІЯ',
      outcome: 'МОЖЛИВИЙ НАПРЯМОК',
      changing: 'МІНЛИВІ ЛІНІЇ',
      structural: 'ЩО ЇЇ УТРИМУЄ',
    },
    insights: {
      analyzing: 'Формуємо тлумачення…',
      transformation:
        '«{{current}}» може перейти до «{{future}}». Мінливі лінії: {{changes}}.',
      stable: 'Мінливих ліній немає. Ситуація зберігає поточний напрямок.',
    },
    changingLines: 'Мінливі лінії',
    changingLinesDescription: 'Ці лінії показують, де ситуація може змінитися.',
    changingLinesTitle: 'Мінливі лінії ({{count}})',
    structuralFocusTitle: 'Що утримує ситуацію',
    structuralFocusDescription:
      'Коли мінливих ліній немає, ці позиції показують, що зараз утримує ситуацію.',
    lineNumber: 'Лінія {{number}}',
    changingLinesNote:
      'Уважно прочитайте ці лінії: вони показують, де відбувається зміна.',
  },
  ask: {
    throw: {
      prepare: 'Коротко сформулюйте запитання й тримайте його в думках.',
      tips: {
        heart: 'Скажіть, що для вас важливо',
        specific: 'Опишіть конкретну ситуацію',
        openEnded: 'Запитайте, що варто врахувати',
      },
      example: 'Наприклад: «Що мені варто врахувати перед рішенням?»',
      guide: {
        title: 'Підготовка',
        bestTime: 'Запитуйте, коли готові спокійно обміркувати відповідь',
        todayGood: 'Залиште час перевірити факти перед важливим рішенням',
      },
    },
    result: {
      sections: {
        future: 'Можливий напрямок',
        present: 'Що відбувається зараз',
        changes: 'Акцент тлумачення',
        structuralFocus: 'Що її утримує',
        advice: 'Як діяти',
      },
      accessibility: {
        advice: 'Як діяти. Порада',
      },
      content: {
        check: 'Запитання для перевірки',
        caution: 'Що врахувати',
        primaryLine: 'Основний акцент',
        secondaryLine: 'Додаткова деталь',
        relatingHint:
          'Похідна гексаграма дає ще одну тему для зіставлення із ситуацією.',
        visibleStructure: 'Як формується ситуація',
        resultStructure: 'Як може розвиватися ситуація',
        hiddenDynamic: 'Що відбувається всередині',
        hiddenCondition: 'Що може вплинути на результат',
        corePattern: 'На що звернути увагу',
        coreTension: 'У чому складність',
        question: 'Ваше питання',
        questionContext: 'У контексті запитання',
        currentAction: 'Що зробити зараз',
        entryCondition: 'Як до цього наблизитися',
        progressMarker: 'Як розпізнати поступ',
      },
      changeDepth: {
        stable:
          'Мінливих ліній немає. Розділ нижче показує, що зараз утримує ситуацію.',
        boundary:
          'Зміна стосується того, як ситуація починається або завершується.',
        internal: 'Зміна стосується того, що відбувається всередині ситуації.',
        systemic: 'Зміна сягає основи ситуації та може змінити її перебіг.',
      },
      buttons: {
        decide: 'Ухвалити рішення',
      },
      more: 'Докладніше',
      skeleton: {
        loading: 'Завантаження…',
      },
    },
    acceptDecision: {
      back: 'Назад',
      title: 'Ухвалити рішення',
      subtitle: 'Додайте контекст, щоб згодом згадати, про що йшлося.',
      reading: 'Основа рішення',
      questionLabel: 'Про що це рішення?',
      questionPlaceholder: 'Коротко опишіть ситуацію або запитання…',
      questionHint: 'Необов’язково. Цей контекст буде збережено в щоденнику.',
      confirm: 'Прийняти та зберегти',
      saving: 'Зберігаємо…',
      cancel: 'Скасувати',
      errorTitle: 'Рішення не збережено',
      errorMessage: 'Спробуйте ще раз.',
    },
  },
  themes: {
    title: 'ТЕМА',
    dark: 'ТЕМНА',
    light: 'СВІТЛА',
    autumn: 'ОСІНЬ',
    active: 'АКТИВНА',
    dark_description: 'Темні поверхні з приглушеними акцентами',
    light_description: 'Чиста сучасна світла тема',
    autumn_description: 'Теплі природні тони, натхненні осінню',
  },
  ui: {
    screenTitle: 'НАЗВА ЕКРАНА',
    info: 'ІНФОРМАЦІЯ',
    language: 'МОВА',
    interfaceSettings: 'Мова та тема',
    loadingStates: {
      loading: 'Завантаження…',
      processing: 'ОБРОБЛЯЄМО…',
      connecting: 'З’ЄДНУЄМОСЬ…',
      deleting: 'ВИДАЛЯЄМО…',
    },
  },
  tabs: {
    home: 'Головна',
    journal: 'Щоденник',
    hexagrams: 'Гексаграми',
    profile: 'Профіль',
  },
  desktop: {
    oracle: 'Оракул',
    brandSubtitle: 'І-Цзін для рішень',
    appearance: 'Оформлення',
    theme: 'Тема інтерфейсу',
  },
  hexagrams: {
    title: 'Гексаграми',
    subtitle: 'Усі 64 знаки І-Цзін — оберіть зручний порядок',
    hint: 'Оберіть знак, щоб відкрити його тлумачення',
    loading: 'Завантажуємо каталог гексаграм…',
    error: 'Не вдалося завантажити каталог гексаграм.',
    retry: 'Спробувати ще раз',
    order: {
      title: 'Порядок',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Fu Xi',
      'fu-xi': 'Fu Xi',
      mawangdui: 'Mawangdui',
    },
    matrix: {
      accessibilityLabel: 'Матриця 64 гексаграм. Порядок: {{order}}',
      cellAccessibilityLabel: 'Гексаграма {{number}}. {{name}}',
    },
    modal: {
      accessibilityLabel: 'Гексаграма {{number}}. {{name}}',
      number: 'Гексаграма {{number}}',
      close: 'Закрити опис гексаграми',
      modernTitle: 'Сучасне тлумачення',
      pattern: 'Що відбувається',
      tension: 'У чому складність',
      structureTitle: 'Структура ситуації',
      visibleStructure: 'Як формується ситуація',
      hiddenDynamic: 'Що відбувається всередині',
      rolesTitle: 'Роль гексаграми',
      initialRole: 'Коли знак описує поточну ситуацію',
      resultingRole: 'Коли знак стає можливим станом',
      roleSummary: 'Значення ролі',
      action: 'Як діяти',
      entry: 'Як увійти в цей стан',
      marker: 'Ознака поступу',
      linesTitle: 'Шість ліній',
      spheresTitle: 'Дія для вашої теми',
      spheres: {
        general: 'Ситуація або вибір',
        newjob: 'Нова робота',
        work: 'Поточна робота',
        love: 'Стосунки',
        project: 'Проєкт',
      },
      dailyTitle: 'Орієнтир на день',
      dailyFocus: 'Тема дня',
      dailyAction: 'Практичний крок',
    },
  },
  journal: {
    actionsFor: 'Дії для «{{title}}»',
    entryActions: 'Дії із записом',
    deleteConfirm: 'Видалити запис?',
    deleteEntry: 'Видалити',
    cancelDelete: 'Скасувати',
    deleting: 'Видаляємо…',
    deleteDailyHint:
      'Цей знак буде видалено. Якщо він поточний, його замінить останній зі збережених знаків за цю дату. Перший знак дня залишиться.',
    deleteReadingHint:
      'Це тлумачення та прийняте за ним рішення буде видалено назавжди.',
    deleteError: 'Не вдалося підтвердити видалення. Спробуйте ще раз.',
    selectEntry: 'Оберіть запис у щоденнику',
    entryNotFound: 'Запис не знайдено. Оберіть інший у списку.',
    title: 'Щоденник',
    filters: {
      all: 'Усі',
      decisions: 'Тлумачення',
      daily: 'Знак дня',
    },
    searchPlaceholder: 'Пошук за назвою та нотаткою',
    empty: 'Тут з’являться ваші тлумачення',
    emptyHint: 'Перше тлумачення з’явиться після «Почати ворожіння»',
    emptyAll: 'Тут з’являться записи вашого щоденника',
    emptyAllHint: 'Тлумачення та знаки дня зберігаються в спільній хронології',
    emptyDecisions: 'Тут з’являться ваші тлумачення',
    emptyDecisionsHint: 'Перше тлумачення з’явиться після «Почати ворожіння»',
    emptyDaily: 'Тут з’являться ваші знаки дня',
    emptyDailyHint: 'Отримайте перший знак на екрані Оракула',
    error: 'Не вдалося завантажити щоденник',
    errorHint: 'Перевірте з’єднання та спробуйте ще раз',
    retry: 'Спробувати ще раз',
    labels: {
      decision: 'Розбір',
      accepted: 'Тлумачення · рішення записано',
      daily: 'Знак дня',
      question: 'Запитання',
    },
  },
  profile: {
    title: 'Профіль',
    account: {
      title: 'Акаунт',
      loginTelegram: 'Продовжити з Telegram',
      loginHint:
        'Історія акаунта буде доступна на різних пристроях; локальні записи залишаться на цьому пристрої',
      loginUnavailable: 'Вхід з’явиться після підключення Telegram Login',
      synchronized: 'Дані акаунта синхронізуються між пристроями',
      logout: 'Вийти',
      loginErrorTitle: 'Не вдалося увійти',
      loginError: 'Telegram не підтвердив вхід. Спробуйте ще раз.',
      logoutErrorTitle: 'Не вдалося вийти',
      logoutError: 'Перевірте з’єднання та спробуйте ще раз.',
    },
    subscription: {
      title: 'Передплата',
      active: 'Активна',
      expired: 'Завершилася',
      free: 'Безкоштовний режим',
      activeUntil: 'Активна до {{date}}',
      manage: 'Керувати передплатою',
      connect: 'Підключити Neiro+',
      restore: 'Відновити покупки',
      hint: 'Доступ до розширених тлумачень, порівнянь та особистих порад.',
      restored: 'Покупки відновлено',
      restoreError: 'Не вдалося відновити покупки',
      purchaseError: 'Не вдалося оформити передплату в App Store',
      loading: 'Перевіряємо стан…',
      benefits: {
        extendedInterpretations: 'Розширені тлумачення',
        personalAdvice: 'Особисті поради',
        comparisons: 'Порівняння варіантів',
      },
      whatsIncluded: 'Що входить?',
    },
    notifications: {
      title: 'Сповіщення',
      morning: 'Ранок',
      morningHint: 'Оберіть час і спосіб отримання ранкового знака',
      morningEnabledDestinationsHint:
        'Знак дня оновлюється о {{time}} · {{destinations}}',
      morningDisabledDestinationsHint:
        'Знак дня оновлюється о {{time}}; сповіщення вимкнено',
      destinations: {
        title: 'Надсилати нагадування до',
        local: 'Цей Mac',
        telegram: 'Telegram',
      },
      timeHint: 'Час початку ранку',
      invalidTime: 'Введіть час у форматі ГГ:ХХ, наприклад 09:00',
      timePicker: {
        title: 'Коли починається ваш ранок?',
        descriptionEnabled:
          'У цей час знак дня оновлюється, а Telegram-бот надсилає нагадування.',
        descriptionEnabledLocal:
          'У цей час знак дня оновлюється, а macOS показує нагадування.',
        descriptionEnabledMultiple:
          'У цей час знак дня оновлюється, а вибрані канали надсилають нагадування.',
        descriptionDisabled:
          'У цей час знак дня оновлюється. Сповіщення залишаться вимкненими.',
        descriptionChannelUnavailable:
          'У цей час знак дня оновлюється. Нагадування почнуть надходити, коли канал Telegram стане доступним.',
        descriptionChannelUnavailableLocal:
          'У цей час знак дня оновлюється. macOS попросить дозвіл на сповіщення.',
        quickChoice: 'Швидкий вибір',
        setPreset: 'Встановити {{time}}',
        hours: 'Години',
        minutes: 'Хвилини',
        decreaseHours: 'Зменшити на одну годину',
        increaseHours: 'Збільшити на одну годину',
        decreaseMinutes: 'Зменшити на п’ять хвилин',
        increaseMinutes: 'Збільшити на п’ять хвилин',
        directEntryHint: 'Точне значення можна ввести з клавіатури',
        invalidHours: 'Введіть годину від 00 до 23',
        invalidMinutes: 'Введіть хвилини від 00 до 59',
      },
      loadError: 'Не вдалося завантажити налаштування ранку',
      saveError: 'Не вдалося зберегти налаштування ранку',
      retry: 'Повторити',
      testSent: 'Тестове повідомлення надіслано в Telegram',
      testSentLocal: 'Тестове сповіщення з’явиться за дві секунди',
      testSentMultiple: 'Тестові нагадування надіслано до вибраних каналів',
      testError: 'Не вдалося надіслати тестове повідомлення',
      channel: {
        active: 'Telegram-бот готовий',
        unverified:
          'Відкрийте Telegram-бота й підтвердьте отримання повідомлень',
        blocked: 'Telegram-бота заблоковано. Розблокуйте його в Telegram',
        disconnected: 'Зв’язок із Telegram-ботом втрачено',
        not_connected: 'Telegram-бота ще не підключено',
      },
      localChannel: {
        active: 'Сповіщення macOS дозволено',
        unverified: 'Дозвіл на сповіщення macOS не підтверджено',
        blocked: 'Дозвольте сповіщення в налаштуваннях macOS',
        disconnected: 'Сповіщення macOS зараз недоступні',
        not_connected: 'Дозвіл буде запитано під час увімкнення нагадувань',
      },
      testNotification: 'Надіслати тест',
    },
    preferences: {
      title: 'Налаштування',
      haptics: 'Тактильний відгук',
      hapticsHint: 'Легка вібрація під час кидка та збереження',
    },
    classicalText: {
      title: 'Тексти гексаграм',
      hint: 'Оберіть сучасне тлумачення, традиційний текст Чжоу І або обидва шари',
      modern: 'Сучасні',
      classical: 'Класичні',
      parallel: 'Обидва',
    },
    language: {
      interface: 'Мова інтерфейсу',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: 'Дані й приватність',
      exportJournal: 'Експорт щоденника',
      exportPeriod: 'Період',
      allData: 'Усі дані',
      last30Days: 'Останні 30 днів',
      export: 'Експортувати',
      exportError: 'Не вдалося експортувати',
      deleteAccount: 'Видалити особисті дані та акаунт',
      deleteAccountHint:
        'Особисті дані, історію, налаштування та акаунт буде видалено із застосунку',
      deleteAccountConfirm:
        'Дані профілю, щоденник, налаштування та акаунт буде видалено. Наступний вхід створить новий акаунт. Залишаться лише технічні підтвердження без вмісту: Telegram — на 7 днів для захисту від повторної обробки, підтвердження видалення — на 30 днів. Після цих строків вони видаляються автоматично.',
      deleteAccountError:
        'Не вдалося видалити особисті дані та акаунт. Перевірте з’єднання та спробуйте ще раз.',
      deleteLocalData: 'Видалити всі особисті дані',
      deleteLocalDataHint:
        'Історію та налаштування, які застосунок зберігає на пристрої, буде видалено',
      deleteLocalDataConfirm:
        'Усі дані, які цей застосунок зберігає на пристрої, буде видалено. Після цього відкриється чистий початковий екран.',
      deleteLocalDataError:
        'Не вдалося видалити дані застосунку. Спробуйте ще раз.',
      cancel: 'Скасувати',
      deleteAccountAction: 'Видалити акаунт',
      deleteLocalDataAction: 'Видалити дані',
      privacy: 'Політика конфіденційності',
      terms: 'Умови використання',
      disclaimer:
        'Для саморефлексії та розваги. Не є медичною чи фінансовою порадою.',
    },
    support: {
      title: 'Підтримка',
      guide: 'Як працює Оракул',
      guideHint: 'Знак дня, тлумачення та щоденник',
      contact: 'Зв’язатися з підтримкою',
      rate: 'Оцінити застосунок',
      rateNow: 'Оцінити зараз',
      version: 'Версія {{version}}',
      devTools: 'Інструменти розробника',
      devToolsDesc:
        'Віддалені налаштування, тестові сповіщення, тестові дані (заглушка)',
    },
    about: {
      title: 'Про застосунок',
      version: 'Версія {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: 'Вирішити зараз',
  },
};
